import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigShippingNoteComponent } from './uig-shipping-note.component';
import { I18nModule } from '@spartacus/core';

@NgModule({
  declarations: [UigShippingNoteComponent],
  imports: [
    CommonModule,
    I18nModule
  ],
  exports: [UigShippingNoteComponent],
})
export class UigShippingNoteModule { }
